"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeepCopy_1 = require("../common/lib/DeepCopy");
var Field_1 = require("../../constants/Field");
var lodash_1 = require("lodash");
var DataItem_1 = require("../common/base/DataItem");
var ConditionOut_1 = require("./ConditionOut");
var FunctionOutputs = /** @class */ (function () {
    function FunctionOutputs() {
        this.updateOutputs();
    }
    FunctionOutputs.fromJson = function (outputsObject) {
        var functionOutputs = new FunctionOutputs();
        var pureOutputs = DeepCopy_1.deepCopy(outputsObject);
        delete pureOutputs[Field_1.FIELD.CONDITIONS];
        functionOutputs.updateOutputs(FunctionOutputs.fromJsonToOutputs(pureOutputs));
        if (outputsObject[Field_1.FIELD.CONDITIONS] !== undefined) {
            functionOutputs.conditions = outputsObject[Field_1.FIELD.CONDITIONS]; // FunctionOutputs.fromJsonToConditions(outputsObject[FIELD.CONDITIONS]);
        }
        return functionOutputs;
    };
    FunctionOutputs.fromJsonToOutputs = function (pureOutputsJson) {
        var outputs = lodash_1.map(Object.keys(pureOutputsJson), function (outputName) {
            return DataItem_1.DataItem.fromJson(outputName, pureOutputsJson[outputName]);
        });
        return outputs;
    };
    FunctionOutputs.fromJsonToConditions = function (conditionsJson) {
        var conditions = lodash_1.map(Object.keys(conditionsJson), function (conditionName) {
            return ConditionOut_1.ConditionOut.fromJson(conditionName, conditionsJson[conditionName]);
        });
        return conditions;
    };
    /**
     * Initializes outputs
     * @param outputs An optional parameter of type Array<FunctionOutput>.
     * If not provided, will initialize with empty array
     */
    FunctionOutputs.prototype.updateOutputs = function (outputs) {
        if (outputs !== undefined) {
            this.outputs = outputs;
        }
        else {
            this.outputs = [];
        }
    };
    FunctionOutputs.prototype.toJson = function () {
        var json = Object.create(null);
        json = Object.assign(this.outputsToJson(), this.conditionsToJson());
        return json;
    };
    /**
     * Converts outputs to json
     */
    FunctionOutputs.prototype.outputsToJson = function () {
        var json = Object.create(null);
        lodash_1.map(this.outputs, function (output) {
            var _a;
            json = Object.assign(json, (_a = {}, _a[output.name] = output.toJson(false), _a));
        });
        return json;
    };
    /**
     * Converts output conditions to json
     */
    FunctionOutputs.prototype.conditionsToJson = function () {
        var json = Object.create(null);
        if (this.conditions !== undefined) {
            json[Field_1.FIELD.CONDITIONS] = this.conditions;
            // map(this.conditions, condition => {
            //     json[FIELD.CONDITIONS] = Object.assign({}, json[FIELD.CONDITIONS], condition.toJson());
            // })
        }
        return json;
    };
    /**
     * Adds or update output condition with its respective alarm variable
     * @param conditionName Output Condition name
     * @param alarmVariable Alarm variable for output condition
     */
    FunctionOutputs.prototype.addAlarm = function (conditionName, alarmVariable) {
        if (this.conditions !== undefined) {
            var conditionOut = this.conditions[conditionName];
            var conditionOutJson = Object.create(null);
            conditionOutJson[conditionName] = alarmVariable;
            if (conditionOut === undefined) {
                this.conditions = Object.assign(this.conditions, conditionOutJson);
            }
            else {
                Object.assign(conditionOut, alarmVariable);
            }
        }
        else {
            var json = Object.create(null);
            json[conditionName] = alarmVariable;
            this.conditions = json;
        }
    };
    return FunctionOutputs;
}());
exports.FunctionOutputs = FunctionOutputs;
//# sourceMappingURL=FunctionOutputs.js.map